export const readStorage = (key, fallback = null) => {
  try {
    const raw = localStorage.getItem(key)

    if (raw === null) {
      return fallback
    }

    try {
      return JSON.parse(raw)
    } catch {
      return raw
    }
  } catch {
    return fallback
  }
}

export const writeStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // localStorage unavailable (private mode, quota exceeded, etc.)
  }
}

export const removeStorage = (key) => {
  try {
    localStorage.removeItem(key)
  } catch {
    // localStorage unavailable
  }
}
